// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const CLICK_HERE = "Klikni sem";
export const SESSION_TIME_OUT_TO_RELOAD_link = "Platnost relace vypr\u0161ela, pre obnoven\u00ed %(link)s.";
